(async () => {

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('main-nav', class extends baseComponent.default {
        elements = {
            dropdowns: '*[data-dropdown]',
            wrappers : "*[data-dropdown-wrapper]"
        };

        modalInit = false;

        render() {
            this.$dropdowns.filter(drop => drop.hasAttribute('data-offset-drop')).map(dropdown => {
                const clientRect = dropdown.getBoundingClientRect();
                if (document.documentElement.clientWidth - clientRect.x + clientRect.width < 600) {
                    dropdown.classList.add('@drop-reverse');
                }
            });

           this.$dropdowns.map(this._handleDropdown.bind(this))
          
        }

          _handleDropdown(drop) {

          var menuItems = this.$wrappers;
          var _this = this;
 
              var hoverIntent = new SV.HoverIntent(menuItems, {
                // required parameters
                onEnter: function(targetItem) {
                    var t = targetItem.querySelector("*[data-dropdown]").dataset.dropdown;
                    const e = targetItem.querySelector(`[data-dropby="${t}"]`);
                    e.classList.toggle("!active");
                },
                onExit: function(targetItem) {
                   var t = targetItem.querySelector("*[data-dropdown]").dataset.dropdown;
                    const e = targetItem.querySelector(`[data-dropby="${t}"]`);
                    e.classList.toggle("!active");
                },
              
                // default options
                exitDelay: 400,
                interval: 100,
                sensitivity: 7,
              });
          
        }

        reRender() {
            if(this.closest('modal-popup') && !this.modalInit) {
                this.modalInit = true;
                this.$dropdowns.map(dropdown => {
                    dropdown.addEventListener('click', (e) => {
                        e.preventDefault();
                        const dropId = e.currentTarget.dataset.dropdown;
                        const dropTarget = this.querySelector(`[data-dropby="${dropId}"]`);
                        dropTarget.classList.toggle('!active');
                    })
                })
            }
        }
    })
})();